import { ChangedHistoryModel } from './changed-history';
import { PaymentHistoryModel } from './payment-history';

export class DepositModel {
    public createdBy!: any;
    public createdDate!: string;
    public curentCNYVN!: any;
    public dathangID!: any;
    public depositCode!: string;
    public feeShipCN!: any;
    public feeShipVND!: any;
    public weightPrice!: any;
    public feeWeight!: any;
    public feeWeightCK!: any;
    public id!: number;
    public isChangeWeightByAdmin!: any;
    public isFeeShip!: any;
    public isCheck!: boolean;
    public isFragileGoods!: boolean;
    public isWrap!: boolean;
    public chinaStoreID!: any;
    public orderWeight!: number;
    public orderVolume!: number;
    public orderWeightRound!: number;
    public extraOption!: number;
    public payment!: number;
    public guaranteeAmount!: number;
    public guaranteeAmountVND!: number;
    public surcharge!: number;
    public feeOther!: number;
    public feeOtherNote!: string;
    public fragileFee!: number;
    public fragileFeeVND!: number;
    public wrapFee!: number;
    public wrapFeeVND!: number;
    public checkFeeType!: number;
    public checkFee!: number;
    public checkFeeVND!: number;
    public receivePlaceID!: number;
    public salerID!: number;
    public status!: number;
    public statusDetail!: any;
    public extraOptionDetail!: any;
    public totalPriceVND!: number;
    public discountVND!: number;
    public uId!: number;
    public updateDateWeightByAdmin!: any;
    public userName!: string;
    public feeShipType!: number;
    public productName!: string;
    public payStatus!: string;
    public numberOfPack!: number;
    public lineType!: number;
    public contractAmount!: number;
    public contractProd!: number;
    public entrustRate!: number;
    public feeEntrust!: number;
    public importTaxRate!: number;
    public importTaxAmount!: number;
    public vatTaxRate!: number;
    public vatTaxAmount!: number;
    
    
    public changedHistories!: ChangedHistoryModel[];
    public paymentHistory!: PaymentHistoryModel[];
};